// Placeholder
NP.Placeholder = (function( $ ) {
	var isSupport = 'placeholder' in document.createElement( 'input' );

	function set( pane ) {
		if ( !isSupport ) {
			pane.find( '[placeholder]' ).addClass( 'placeholder' ).each(function() {
				var el = $( this );
				el.val( el.attr( 'placeholder' ) );
			});
		}
	}

	if ( !isSupport ) {
		NP.body.on( 'focusin', '[placeholder]', function() {
			var el = $( this ).addClass( 'focus' );

			if ( el.attr( 'placeholder' ) === el.val() ) {
				el.val( '' );
				el.removeClass( 'placeholder' );
			}
		});

		NP.body.on( 'focusout', '[placeholder]', function() {
			var el = $( this ).removeClass( 'focus' );

			if ( !el.val().length ) {
				el.addClass( 'placeholder' );
				el.val( el.attr( 'placeholder' ) );
			}
		});

		NP.onProcessing.add( set );
		set( NP.body );
	}

	return {
		isSupport : isSupport,
		set : set
	};
}( jQuery ));
